import type { SupplierDirectoryListItem } from '@tandemone/types'
import type { ColumnDef } from '@tanstack/react-table'
import { ArrowRight } from 'lucide-react'

import { DataTableColumnHeader } from '@/components/ui/data-table-column-header'
import { CertificationsCell } from '@/domains/supplier-profile'

import { FavoriteStar } from './favorite-star'
import { FoundingBadge } from './founding-badge'
import { SupplierVerifiedBadge } from './status-badge'

export const supplierDirectoryColumns: ColumnDef<SupplierDirectoryListItem>[] =
  [
    {
      id: 'favorite',
      header: '',
      enableSorting: false,
      meta: { width: '44px' },
      cell: ({ row }) => (
        <FavoriteStar
          slug={row.original.companySlug}
          supplierId={row.original.supplierId}
          isFavorited={row.original.isFavorited}
        />
      )
    },
    {
      accessorKey: 'companyName',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title='Name' />
      ),
      cell: ({ row }) => (
        <div className='flex min-w-0 flex-col leading-tight'>
          {row.original.isFoundingSupplier ? <FoundingBadge /> : null}
          <span className='block truncate font-medium'>
            {row.original.companyName}
          </span>
        </div>
      )
    },
    {
      accessorKey: 'country',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title='Country' />
      ),
      cell: ({ row }) => (
        <span className='block truncate'>{row.original.country ?? '—'}</span>
      )
    },
    {
      accessorKey: 'region',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title='Region' />
      ),
      cell: ({ row }) => (
        <span className='block truncate'>{row.original.region ?? '—'}</span>
      )
    },
    {
      accessorKey: 'certifications',
      header: 'Certifications',
      enableSorting: false,
      cell: ({ row }) => (
        <CertificationsCell certifications={row.original.certifications} />
      )
    },
    {
      accessorKey: 'status',
      header: 'Status',
      enableSorting: false,
      meta: { width: '140px' },
      cell: ({ row }) => <SupplierVerifiedBadge status={row.original.status} />
    },
    {
      id: 'action',
      header: '',
      enableSorting: false,
      meta: { width: '56px', align: 'right' },
      cell: () => (
        <div className='flex justify-end'>
          <ArrowRight className='size-4 text-ink-muted transition-transform group-hover:translate-x-0.5 group-hover:text-accent dark:group-hover:text-accent-mid' />
        </div>
      )
    }
  ]

export const publicSupplierDirectoryColumns = supplierDirectoryColumns.filter(
  column => column.id !== 'favorite'
)
